import React from "react";

export function lazyImport(factory) {
    return React.lazy(factory);
}
